import React, { useRef, useState } from "react";
import Chart from "react-apexcharts";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { appLogger } from "../../../utils";
import { chartHighlighter } from "../../../utils/common/chartHighlighter";

interface chartData {
  total: number;
  avg: number;
  data: Object;
}
interface categoryChartProps {
  bugReportChartData: chartData;
  setChartData: any;
  chartShow: any;
  filter: any;
  selected: any;
}

const TicketSeverityGraph = (props: categoryChartProps) => {
  appLogger.info({
    infoObj: {
      method: " TicketSeverityGraph",
      component: "dashboard",
      fileName: "DashBugReportchart.tsx",
      props: props,
    },
  });
  const ref = useRef<HTMLElement>(null);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const { bugReportChartData, chartShow, filter, selected } = props;
  // const categoriesValue: string[] = Object.keys(bugReportChartData.data);
  const chartData: number[] = Object.values(bugReportChartData.data);

  const getCatValue = Object.keys(bugReportChartData.data);
  const categoriesValue: string[] = getCatValue.map(
    (sev) => sev.charAt(0).toUpperCase() + sev.slice(1)
  );

  const barSize = () => {
    let size = "";

    if (categoriesValue.length >= 5) {
      size = "80%";
    } else if (categoriesValue.length == 4) {
      size = "60%";
      return size;
    } else if (categoriesValue.length == 3) {
      size = "40%";
      return size;
    } else if (categoriesValue.length == 2) {
      size = "30%";
      return size;
    } else if (categoriesValue.length == 1) {
      size = "15%";
      return size;
    }

    return size;
  };

  const options = {
    xaxis: {
      title: {
        text: "(Severity)",
        offsetY: -4,
        style: {
          fontSize: "10px",
          fontWeight: "400",
          fontFamily: "Poppins",
        },
      },
      show: true,
      categories: categoriesValue,
      lines: {
        show: false, //or just here to disable only x axis grids
      },
      labels: {
        show: true,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    tooltip: {
      custom: function (config: any) {
        return (
          `<div class="custom-tooltip" style="background: ${config.w.config.fill.colors[0]}">` +
          "<h2 class='tooltip-title'>Severity :" +
          "<span>" +
          config.w.globals.labels[config.dataPointIndex] +
          "</span>" +
          "</h2>" +
          "<div class='tooltip-info'>" +
          config.w.globals.series[0][config.dataPointIndex] +
          "<span>" +
          `(${
            config.w.globals.series[0][config.dataPointIndex] > 0
              ? Math.floor(
                  (config.w.globals.series[0][config.dataPointIndex] /
                    config.w.globals.seriesTotals[0]) *
                    100
                )
              : 0
          }%)` +
          "</span></div>" +
          "</div>"
        );
      },
    },
    yaxis: {
      show: true,
      title: {
        text: "(Counts)",
        offsetX: 4,
        style: {
          fontSize: "10px",
          fontWeight: "400",
          fontFamily: "Poppins",
        },
      },
    },
    fill: {
      colors: ["#ff8652"],
    },
    chart: {
      // events: {
      //   dataPointSelection: function (
      //     event: any,
      //     chartContext: any,
      //     config: any
      //   ) {
      //     // click: function (event: any, chartContext: any, config: any) {
      //     appLogger.info({
      //       infoObj: {
      //         method: "dataPointSelection",
      //         component: "dashboard",
      //         fileName: "BugReportChart.tsx",
      //         config: config,
      //       },
      //     });

      //     const dataPointIndexValue = config.dataPointIndex;

      //     chartHighlighter([dataPointIndexValue], ref.current, "bar");

      //     const selectedFilterLabel =
      //       config.w.globals.labels[dataPointIndexValue];
      //     const selectedFilterValue =
      //       config.w.config.series[0].data[dataPointIndexValue];
      //     appLogger.info({
      //       infoObj: {
      //         method: "dataPointSelection",
      //         component: "dashboard",
      //         fileName: "BugReportChart.tsx",
      //         data: { selectedFilterLabel, selectedFilterValue },
      //       },
      //     });

      //     const test = {
      //       // name: "",
      //       // filters: [
      //       // {
      //       field: "RATINGS",
      //       operation: "contains",
      //       value:
      //         config.selectedDataPoints[0]?.length > 0
      //           ? [selectedFilterLabel]
      //           : [],
      //       // },
      //       // ],
      //       // advanceFilters: [],
      //     };
      //     navigate("/feedback", {
      //       state: {
      //         pageType: "BUG_REPORT",
      //         ratingsClicked: test,
      //       },
      //     });
      //     props.setChartData(test);
      //   },
      //   updated: function (config: any) {
      //     const dataPointIndexValue = config.dataPointIndex;
      //     const selectedFilterLabel =
      //       config.w.globals.labels[dataPointIndexValue];

      //     const modifiedFilter = filter?.filters?.find(
      //       (data: any) => data.field === "RATINGS"
      //     )?.value;

      //     // const k =
      //     //   config?.w?.globals?.labels.length > 0 &&
      //     //   config?.w?.globals?.labels?.findIndex(
      //     //     (e: any) => e === modifiedFilter[0]
      //     //   );
      //     const k =
      //       config &&
      //       config?.w?.globals?.labels
      //         ?.map((o: any) => o)
      //         .indexOf(modifiedFilter && modifiedFilter[0]);

      //     chartHighlighter([k], ref.current, "bar");

      //     config.w.globals.selectedDataPoints[0] =
      //       filter?.filters?.length === 1 && !selected ? [k] : [];
      //   },
      //   mounted: function (config: any) {
      //     const dataPointIndexValue = config.dataPointIndex;
      //     const selectedFilterLabel =
      //       config.w.globals.labels[dataPointIndexValue];

      //     const modifiedFilter = filter?.filters?.find(
      //       (data: any) => data.field === "RATINGS"
      //     ).value;

      //     const k =
      //       config &&
      //       config?.w?.globals?.labels
      //         ?.map((o: any) => o)
      //         ?.indexOf(modifiedFilter && modifiedFilter[0]);

      //     chartHighlighter([k], ref.current, "bar");

      //     config.w.globals.selectedDataPoints[0] =
      //       filter?.filters?.length === 1 && !selected ? [k] : [];
      //   },
      // },
      toolbar: {
        export: {
          csv: {
            filename: "CuVo_Bugs",
          },
          svg: {
            filename: "CuVo_Bugs",
          },
          png: {
            filename: "CuVo_Bugs",
          },
        },
      },
    },
    plotOptions: {
      bar: {
        // horizontal: false,
        dataLabels: {
          position: "center",
        },
        columnWidth: barSize(),
        colors: {
          ranges: [
            {
              from: 0,
              to: 0,
              color: undefined,
            },
          ],
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  // setTimeout(() => {
  //   setShow(true);
  // }, 2000);

  const series = [
    {
      name: "series-1",
      data: chartData.length > 0 ? chartData : [1],
    },
  ];

  return (
    <>
      {chartShow && categoriesValue.length > 0 && (
        <Box
          ref={ref}
          className="rating-chart-wrap bug-chart"
          sx={{
            height: "318px !important",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Chart
            options={options}
            series={series}
            width={350}
            height={250}
            type="bar"
          />
        </Box>
      )}

      {chartShow && categoriesValue.length < 1 && (
        <Typography className="no-data">no data</Typography>
      )}
    </>
  );
};

export default TicketSeverityGraph;
